// e3-bundler-lightbox.js
// "BUNDLE & SAVE" trigger button + lightbox for the Bundler.app product-page widget.
//
// Strategy:
//   - The inline Bundler widget (#bundler-target-element) is default-hidden off-screen
//     by e3-bundler-lightbox.css (CSS-only — no flash, lets Bundler still init/measure).
//   - A "BUNDLE & SAVE" button is injected below Add-to-Cart, revealed ONLY when Bundler
//     actually rendered a bundle for this product (bundler:bundle_widget_created).
//   - On click we RELOCATE the live #bundler-target-element node into the modal body so
//     Bundler's event handlers, variant <select>s, and add-to-cart stay fully functional
//     (rebuilding as static markup would break the bundle's add-to-cart). On close it is
//     moved back to its home position so Bundler re-renders find it where expected.
//   - ALL styling/layout (horizontal carousel, card stack) lives in CSS, scoped under
//     .e3-bundler-modal. This supersedes the old e3-custom.js inline-style restyle, which
//     was wiped on every re-render; CSS re-resolves the cascade automatically instead.

(function () {
  'use strict';

  var TRIGGER_ID = 'e3-bundle-trigger';
  var MODAL_ID = 'e3-bundler-modal';
  // Bundler's mount is a CLASS (.bundler-target-element) with a dynamic id
  // (_bndl_key_*) — there is NO stable #bundler-target-element id. Works for
  // both regular and mix-&-match bundles.
  var WIDGET_SEL = '.bundler-target-element';
  var BODY_SEL = '.e3-bundler-modal__body';

  var GIFT_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M20 12v9H4v-9"/><path d="M2 7h20v5H2z"/><path d="M12 22V7"/>' +
    '<path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>' +
    '<path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';

  var X_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';

  var lastFocused = null;
  var placeholder = null; // marks the widget's home position for move-back on close
  var observer = null;

  function widget() {
    return document.querySelector(WIDGET_SEL);
  }

  // A bundle is present for THIS product only when Bundler actually rendered
  // product cards into the mount. (getBundles() lists every configured bundle
  // app-wide, so it can't be used here — it would reveal the button on products
  // that have no widget.) The empty .bundler-target-element placeholder that
  // Bundler leaves on non-bundle products has no .bndlr-product children.
  function hasBundle() {
    var w = widget();
    return !!(w && w.querySelector('.bndlr-product'));
  }

  // ---- one-time shell injection -------------------------------------------
  function buildShell() {
    if (document.getElementById(TRIGGER_ID)) return true;

    var form = document.querySelector('product-form-component.product-form') ||
               document.querySelector('product-form-component');
    if (!form) return false; // not a product page / ATC not rendered yet

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = TRIGGER_ID;
    btn.className = 'e3-bundle-trigger';
    btn.hidden = true;
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.innerHTML =
      '<span class="e3-bundle-trigger__icon" aria-hidden="true">' + GIFT_SVG + '</span>' +
      '<span class="e3-bundle-trigger__label">Bundle &amp; Save</span>' +
      '<span class="e3-bundle-trigger__chev" aria-hidden="true">&rsaquo;</span>';
    form.insertAdjacentElement('afterend', btn);

    var modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.className = 'e3-bundler-modal';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'e3-bundler-modal-title');
    modal.innerHTML =
      '<div class="e3-bundler-modal__overlay" data-e3-close></div>' +
      '<div class="e3-bundler-modal__dialog" role="document">' +
        '<div class="e3-bundler-modal__header">' +
          '<h2 class="e3-bundler-modal__title" id="e3-bundler-modal-title">Build Your Kit &amp; Save</h2>' +
          '<button type="button" class="e3-bundler-modal__close" data-e3-close aria-label="Close">' + X_SVG + '</button>' +
        '</div>' +
        '<div class="e3-bundler-modal__body"></div>' +
      '</div>';
    document.body.appendChild(modal);

    btn.addEventListener('click', openModal);
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-e3-close]')) closeModal();
    });
    return true;
  }

  function ensurePlaceholder() {
    var w = widget();
    if (!w) return;
    if (!placeholder) placeholder = document.createComment('e3-bundler-home');
    if (!placeholder.parentNode && w.parentNode && !inModal(w)) {
      w.parentNode.insertBefore(placeholder, w);
    }
  }

  function inModal(node) {
    var body = document.querySelector(BODY_SEL);
    return !!(body && body.contains(node));
  }

  // ---- reveal / re-sync ----------------------------------------------------
  function reveal() {
    var btn = document.getElementById(TRIGGER_ID);
    if (btn && hasBundle()) btn.hidden = false;
  }

  // Keep the freshest widget node inside the modal while it's open. If Bundler
  // re-rendered and re-injected a new #bundler-target-element at home, swap it in
  // and drop the stale parked copy. (Re-render behavior is untested in prod —
  // this + the MutationObserver are the belt-and-suspenders mitigation.)
  function syncWidgetLocation() {
    var modal = document.getElementById(MODAL_ID);
    if (!modal || modal.hidden) return;
    var body = modal.querySelector(BODY_SEL);
    if (!body) return;
    var nodes = document.querySelectorAll(WIDGET_SEL);
    if (!nodes.length) return;
    if (nodes.length === 1) {
      if (nodes[0].parentNode !== body) body.appendChild(nodes[0]);
      return;
    }
    var fresh = null;
    Array.prototype.forEach.call(nodes, function (n) { if (!body.contains(n)) fresh = n; });
    Array.prototype.forEach.call(nodes, function (n) {
      if (n !== fresh && body.contains(n) && n.parentNode) n.parentNode.removeChild(n);
    });
    if (fresh) body.appendChild(fresh);
  }

  function setupObserver() {
    if (observer) return;
    ensurePlaceholder();
    if (!placeholder || !placeholder.parentNode) return;
    observer = new MutationObserver(function () { reveal(); syncWidgetLocation(); });
    observer.observe(placeholder.parentNode, { childList: true });
  }

  // ---- open / close --------------------------------------------------------
  function openModal() {
    var modal = document.getElementById(MODAL_ID);
    var w = widget();
    if (!modal || !w) return;
    ensurePlaceholder();
    var body = modal.querySelector(BODY_SEL);
    body.appendChild(w); // relocate live node — handlers intact
    lastFocused = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('e3-modal-open');
    document.addEventListener('keydown', onKeydown);
    var close = modal.querySelector('.e3-bundler-modal__close');
    if (close) close.focus();
  }

  function closeModal() {
    var modal = document.getElementById(MODAL_ID);
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.classList.remove('e3-modal-open');
    document.removeEventListener('keydown', onKeydown);
    var w = widget();
    if (w && placeholder && placeholder.parentNode) {
      placeholder.parentNode.insertBefore(w, placeholder); // move back home (re-hidden by CSS)
    }
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { closeModal(); return; }
    if (e.key === 'Tab') trapFocus(e);
  }

  function trapFocus(e) {
    var modal = document.getElementById(MODAL_ID);
    if (!modal) return;
    var sel = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), ' +
              'textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var f = Array.prototype.filter.call(modal.querySelectorAll(sel), function (el) {
      return el.offsetParent !== null;
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  // ---- wiring --------------------------------------------------------------
  function onBundlerActivity() {
    buildShell();
    reveal();
    setupObserver();
    syncWidgetLocation();
  }

  document.addEventListener('bundler:loaded', onBundlerActivity);
  document.addEventListener('bundler:bundle_widget_created', onBundlerActivity);

  // Always redirect to checkout after a bundle is added to cart.
  // This store runs page-cart mode (no drawer). Bundler's own post-add redirect
  // is a same-tab location navigation to the discounted Shopify checkout —
  // VERIFIED live: window.bndlr.checkout() navigates to /checkouts/cn/… with NO
  // window.open (so it is NOT popup/gesture-blocked). On desktop Bundler triggers
  // it; on mobile it gets skipped (the page-cart `/cart` navigation appears to win),
  // so we trigger the same checkout() ourselves. Desktop just races to the same
  // checkout (harmless). checkout() navigates away, so the guard only matters if
  // the event somehow double-fires before unload.
  var e3CheckoutTriggered = false;
  document.addEventListener('bndlr:bundle_added_to_cart', function () {
    if (e3CheckoutTriggered) return;
    e3CheckoutTriggered = true;
    if (typeof window.bndlr !== 'undefined' && typeof window.bndlr.checkout === 'function') {
      window.bndlr.checkout();
    } else {
      window.location.href = '/checkout';
    }
  });

  // In case Bundler rendered before this deferred script ran (event already fired).
  buildShell();
  reveal();
})();
